import { salesforceGetQuery } from 'api';

export const getSalesforceOrderByOrderId = async ({ simplrAccountPtrId, orderId }) => {
  try {
    const api = `/getOrderByOrderId`;
    const query = {
      orderId,
      simplrAccountPtrId,
    };

    return await salesforceGetQuery(api, query);
  } catch (error) {
    throw error;
  }
};

export const getSalesforceOrderByEmail = async ({ simplrAccountPtrId, email }) => {
  try {
    const api = `/getOrderByEmail`;
    const query = {
      email,
      simplrAccountPtrId,
    };

    return await salesforceGetQuery(api, query);
  } catch (error) {
    throw error;
  }
};
